export default {
	title: "",
	subtitle: "Dynamic PIX (QR Code)",
  path: "transaction_pix_dynamic",
	paragraphs: [
		"For Dynamic PIX payments, you’ll need to create a transaction with the transaction endpoint. This type of payment requires a fixed value to be paid, and an expiration date. You will request for the dynamic pix, and we will return with a code that you will transform into the QR Code to share with the customer. Unlike the static, the dynamic QR code is unique for each payer, expirable, and its amount cannot be changed once it's generated.",
		"You will also get a payment_expired webhook if it's not paid within the expiration date. Besides the 'use_dynamic_pix' flag, you'll also need to provide the expiration date."
	],
	request:  {
		method: "POST",
		endpoint: "/transactions",
		payload: {
			"transaction": {
				"subject_id": "customer id",
				"from_bank_account_id": "your real BRL account id",
				"to_bank_account_id":  "the internal BRL cash in id",
				"currency": "BRL",
				"exchange_currency": "BRL",
				"value": "1500.00",
				"use_dynamic_pix": true,
        		"dynamic_pix_expires_at": "2025-05-08T08:30:44.074Z"
			}
		},
		responses: {
			"data": {
				"value": "1500.00",
				"to_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "Power HT Co. Ltd.",
					"owner_document_number": "1589632472",
					"owner_company": {
						"social_name": "POWER HOME THEATER",
						"id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
						"document_type": "tax_id",
						"document_number": "2348909854385"
					},
					"internal": true,
					"intermediary_bank_account": null,
					"id": "9b95f84e-de61-460b-a14b-f23b4e71c97b",
					"iban": null,
					"flow_type": "cash_in",
					"currency": "BRL",
					"branch_number": null,
					"branch_country": null,
					"bank": {
						"swift": null,
						"name": "Internal",
						"id": "6facab8d-573e-44d0-a4bd-ce2600368263",
						"code": "999"
					},
					"account_type": "conta-corrente",
					"account_number": null,
					"aba": null
				},
				"subject_is_receiver": false,
				"subject_id": "f5d357c6-7655-43f8-9e9f-8eebc2cecad1",
				"subject": {
					"updated_at": "2022-07-07T20:46:06.507246",
					"status": "approved",
					"social_name": "Machado de Assis",
					"required_clearance_level": 1,
					"references": [],
					"phone_number": "3138894070",
					"net_monthly_average_income": "0.00",
					"inserted_at": "2021-03-11T00:47:52.287547",
					"id": "f5d357c6-7655-43f8-9e9f-8eebc2cecad1",
					"fiscal_country": "Brasil",
					"email": "client@gmail.com",
					"document_type": "cpf",
					"document_number": "12345678909",
					"clearance_level": 1,
					"birth_date": "1994-04-01",
					"address_street": "Rua Barão do Rio Negro",
					"address_state": "SP",
					"address_postal_code": "16201220",
					"address_number": "310",
					"address_country": "Brasil",
					"address_complement": "Apt. 44 A",
					"address_city": "Birigui"
				},
				"status": "pending",
				"source_name": "Machado de Assis",
				"source_document_type": "cpf",
				"source_document_number": "12345678909",
				"meta": null,
				"inserted_at": `${new Date(Date.now()).toISOString()}`,
				"id": "b0a21c5f-56bd-40ef-9359-f2b573ae3883",
				"from_credit_card": null,
				"from_bank_account": {
					"routing_number": null,
					"pix_info": {
						"type": "email",
						"key": "partnercompany@facilitapay.com"
					},
					"owner_name": "FACILITA FX MERCANTIL FINANCEIRO LTDA",
					"owner_document_number": "10789035000105",
					"intermediary_bank_account_id": null,
					"id": "8b2812f0-d6c8-4073-97bb-9fa964d08bc5",
					"iban": null,
					"currency": "BRL",
					"branch_number": "0311",
					"branch_country": "Brasil",
					"bank": {
						"swift": "PLURBRRJ",
						"name": "BRASIL PLURAL S.A. BANCO MÚLTIPLO",
						"id": "292c1958-4926-4c7d-8550-6ce9c0952552",
						"code": "125"
					},
					"account_type": "conta-corrente",
					"account_number": "562001-1",
					"aba": null
				},
				"for_exchange": true,
				"exchanged_value": "279.85",
				"exchange_under_request": false,
				"exchange_currency": "USD",
				"estimated_value_until_exchange": false,
				"dynamic_pix_code": "00020101021226990014br.gov.bcb.pix2577pix.bancogenial.com/qrs1/v2/017si5czJTt4zOys319ukH9l1UD8m94JJ0xnElX3Bc6rMK3ug52040000530398654041.005802BR5923FACILITA PAGAMENTOS S/A6009SAO PAULO62070503***6304B8B8",
				"currency": "BRL",
				"cleared": true,
				"bank_transaction": null
			}
		}
	},
	parameterPayload: [
		{
           name: "transaction",
           type: "object",
           required: true,
           description: "An object containing all the required values needed"
        },
		{
			name: "transaction.subject_id",
			type:  "UUID",
			required: true,
			description: "The ID generated when you registered you customer as one of your subjects"
		},
		{
			name: "transaction.from_bank_account_id",
			type: "UUID",
			required: true,
			description: "The ID of the BRL exclusive bank account that we opened for you."
		},
		{
			name: "transaction.to_bank_account_id",
			type:  "UUID",
			required: true,
			description: "The destination bank account ID whose currency is equals to the \"exchange_currency\" field"
		},
		{
			name: "transaction.currency",
			type: "string",
			required: true,
			description: "Must be \"BRL\" for pix transaction"
		},
		{
			name: "transaction.exchange_currency",
			type: "string",
			required: true,
			description: "One of: BRL, USD or EUR"
		},
		{
			name: "transaction.use_dynamic_pix",
			type: "boolean",
			required: true,
			description: "Must be true for pix transaction. You don't need to send this field for other payment methods"
		},
		{
			name: "transaction.value",
			type: "string",
			required: true,
			description: "Amount you want to charge with two decimal places only, e.g.: \"1500.00\""
		},
		{
			name: "transaction.dynamic_pix_expires_at",
			type: "date time",
			required: false,
			description: "Future date at least more than 1 minute ahead of the current UTC date time. Format: YYYY-MM-DDThh:mm:ssZ"
		}
	],
	troubleshooting: {
		title: 'Common Mistakes',
		messages: [
			{
				code: {
					"from_bank_account_id": "does not support dynamic pix"
				},
				solution: 'You used an account that does not have a pix key registered on the portal. Contact our support team and share the request/response. We\'ll set up a pix account for you.'
			},
			{
				code: {
					"dynamic_pix_expires_at": "is invalid"
				},
				solution: 'You must use a date time format. Check in the \"Body Parameters\" section above'
			},
			{
				code: {
					"dynamic_pix_expires_at": "must be a future date"
				},
				solution: 'You must use a future date with more the 1 minute ahead of the current UTC date time'
			}
		]
	}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPixDynamic.js